module.exports = __webpack_public_path__ + "static/media/SVMS Logo Final-A-FULL-MED.00ee6f4b.png";